module.exports = __webpack_public_path__ + "img/dec4_05.a6075f90.jpeg";